export const navItemSecondaryActionButtonVisibilityStyles = (open: boolean) => {
  return open ? openedStyles : undefined;
};

const openedStyles = {
  visibility: "visible !important",
  bgcolor: "grey.200",
};
